module.exports = __webpack_public_path__ + "static/media/ico_notify.dd5b8a42.svg";